import gql from 'graphql-tag';

const Query = {
  documents: gql`
    query documents($filters: DocumentFilters, $pagination: PageInfoInput, $orderBy: DocumentInput) {
      documents(filters: $filters, pagination: $pagination, orderBy: $orderBy) {
        nbHits
        hits {
          id
          public_url
          mimetype
          filename
          encoding
          updatedAt
          cmsPageId
          documentsAssocs {
            order
            visible
            display_location
            propertyId
            opportunityId
            type
          }
        }
      }
    }
  `,
  documentsByProperty: gql`
    query documentsByProperty($propertyId: Int!, $location: String) {
      documentsByProperty(propertyId: $propertyId, location: $location) {
        id
        order
        visible
        public_url
        mimetype
        filename
        encoding
        updatedAt
      }
    }
  `,
  contactInfoPictures: gql`
    query contactInfoPictures($contactsInfoId: Int!) {
      contactInfoPictures(contactsInfoId: $contactsInfoId) {
        public_url
      }
    }
  `,
  contactDocuments: gql`
    query contactDocuments($contactId: Int!) {
      contactDocuments(contactId: $contactId) {
        assoc_type
        createdAt
        display_location
        encoding
        filename
        id
        mimetype
        order
        public_url
        updatedAt
        visible
      }
    }
  `,
  contactInfosCandidateDocuments: gql`
    query contactInfosCandidateDocuments($contactInfoId: Int!, $categories: [ContactDocumentCategory]) {
      contactInfosCandidateDocuments(contactInfoId: $contactInfoId, categories: $categories) {
        assoc_id
        createdAt
        display_location
        encoding
        filename
        id
        mimetype
        order
        public_url
        updatedAt
        visible
        category
      }
    }
  `,
  generateSignedUrl: gql`
    query generateSignedUrl($url: String!, $filename: String!) {
      generateSignedUrl(url: $url, filename: $filename) {
        signedUrl
      }
    }
  `,
};

const Mutation = {
  singleUpload: gql`
    mutation singleUpload($folderName: String!, $file: Upload!, $location: String) {
      singleUpload(folderName: $folderName, file: $file, location: $location) {
        public_url
      }
    }
  `,
  multiUpload: gql`
    mutation multiUpload($folderName: String!, $files: [Upload!]!, $location: String) {
      multiUpload(folderName: $folderName, files: $files, location: $location) {
        public_url
      }
    }
  `,
  uploadDocument: gql`
    mutation uploadPropertyPictures($propertyId: Int!, $opportunityId: Int, $files: [Upload!]!, $location: String) {
      uploadPropertyPictures(
        propertyId: $propertyId
        opportunityId: $opportunityId
        files: $files
        location: $location
      ) {
        public_url
      }
    }
  `,
  deleteDocument: gql`
    mutation deletePropertyPicture($id: Int!, $opportunityId: Int) {
      deletePropertyPicture(id: $id, opportunityId: $opportunityId)
    }
  `,
  setPropertyPicturesOrder: gql`
    mutation setPropertyPicturesOrder($params: [propertyPictureOrderInput]) {
      setPropertyPicturesOrder(params: $params)
    }
  `,
  setPropertyPictureVisible: gql`
    mutation setPropertyPictureVisible($id: Int!, $isVisible: Boolean!) {
      setPropertyPictureVisible(id: $id, isVisible: $isVisible)
    }
  `,
  uploadContactInfosDocuments: gql`
    mutation uploadContactInfosDocuments(
      $contactInfoId: Int!
      $files: [Upload!]!
      $location: String
      $category: String
      $uniqueInCategory: Boolean
    ) {
      uploadContactInfosDocuments(
        contactInfoId: $contactInfoId
        files: $files
        location: $location
        category: $category
        uniqueInCategory: $uniqueInCategory
      ) {
        public_url
      }
    }
  `,
  uploadContactInfosProfilImage: gql`
    mutation uploadContactInfosProfilImage($contactInfoId: Int!, $files: [Upload!]!) {
      uploadContactInfosProfilImage(contactInfoId: $contactInfoId, files: $files) {
        public_url
      }
    }
  `,
  uploadContactDocuments: gql`
    mutation uploadContactDocuments($contactId: Int!, $files: [Upload!]!, $location: String) {
      uploadContactDocuments(contactId: $contactId, files: $files, location: $location) {
        public_url
      }
    }
  `,
  deleteContactDocument: gql`
    mutation deleteContactDocument($id: Int!) {
      deleteContactDocument(id: $id)
    }
  `,
  setContactDocumentsOrder: gql`
    mutation setContactDocumentsOrder($params: [contactDocumentOrderInput]) {
      setContactDocumentsOrder(params: $params)
    }
  `,
  setContactDocumentsType: gql`
    mutation setContactDocumentsType($params: [contactDocumentTypeInput]) {
      setContactDocumentsType(params: $params)
    }
  `,
  setContactDocumentVisible: gql`
    mutation setContactDocumentVisible($id: Int!, $isVisible: Boolean!) {
      setContactDocumentVisible(id: $id, isVisible: $isVisible)
    }
  `,

  uploadContactInfoPicture: gql`
    mutation uploadContactInfoPicture($contactInfoId: Int!, $url: String!, $fileName: String!) {
      uploadContactInfoPicture(contactInfoId: $contactInfoId, url: $url, fileName: $fileName) {
        name
        filename
      }
    }
  `,
  saveDocumentToFileManager: gql`
    mutation saveDocumentToFileManager($files: [Upload!]!, $name: String) {
      saveDocumentToFileManager(files: $files, name: $name)
    }
  `,
};

export default {
  Query,
  Mutation,
};
